import React from 'react';

interface LongReceiptProps {
  size?: string | number;
  fill?: string;
}

const LongReceipt = ({ size = '15', fill = '#231F20' }: LongReceiptProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.49933 15.9806C1.91708 15.9806 1.42429 15.779 1.02097 15.3757C0.617668 14.9724 0.416016 14.4796 0.416016 13.8973V11.814H2.91602V0.307617L4.06987 1.3012L5.23972 0.307617L6.4096 1.3012L7.57945 0.307617L8.74933 1.3012L9.9192 0.307617L11.0891 1.3012L12.2589 0.307617L13.4288 1.3012L14.5826 0.307617V13.8973C14.5826 14.4796 14.381 14.9724 13.9777 15.3757C13.5744 15.779 13.0816 15.9806 12.4993 15.9806H2.49933ZM12.4993 14.7307C12.7354 14.7307 12.9334 14.6508 13.0931 14.4911C13.2528 14.3314 13.3327 14.1334 13.3327 13.8973V2.23066H4.16599V11.814H11.666V13.8973C11.666 14.1334 11.7459 14.3314 11.9056 14.4911C12.0653 14.6508 12.2632 14.7307 12.4993 14.7307ZM5.1596 5.35564V4.10568H9.88714V5.35564H5.1596ZM5.1596 7.85564V6.60568H9.88714V7.85564H5.1596ZM11.6179 5.46783C11.4139 5.46783 11.24 5.39598 11.0963 5.25229C10.9526 5.10859 10.8807 4.93472 10.8807 4.73066C10.8807 4.5266 10.9526 4.35273 11.0963 4.20903C11.24 4.06534 11.4139 3.99349 11.6179 3.99349C11.822 3.99349 11.9958 4.06534 12.1395 4.20903C12.2832 4.35273 12.3551 4.5266 12.3551 4.73066C12.3551 4.93472 12.2832 5.10859 12.1395 5.25229C11.9958 5.39598 11.822 5.46783 11.6179 5.46783ZM11.6179 7.96783C11.4139 7.96783 11.24 7.89598 11.0963 7.75228C10.9526 7.60859 10.8807 7.43471 10.8807 7.23066C10.8807 7.0266 10.9526 6.85273 11.0963 6.70903C11.24 6.56534 11.4139 6.49349 11.6179 6.49349C11.822 6.49349 11.9958 6.56534 12.1395 6.70903C12.2832 6.85273 12.3551 7.0266 12.3551 7.23066C12.3551 7.43471 12.2832 7.60859 12.1395 7.75228C11.9958 7.89598 11.822 7.96783 11.6179 7.96783ZM2.49933 14.7307H10.416V13.064H1.66599V13.8973C1.66599 14.1334 1.74586 14.3314 1.90558 14.4911C2.0653 14.6508 2.26322 14.7307 2.49933 14.7307Z"
        fill={fill}
      />
    </svg>
  );
};

export default LongReceipt;
